export enum OverviewRoutesEnum {
  TEMPERATURE = 'temperature',
  PRECIPITATION = 'precipitation',
  RENEWABLES = 'renewables',
  DEMAND = 'demand',
  WEIGHTED = 'weighted',
  FRESH_LOOK = 'fresh-look',
  MAPS = 'maps',
}
